import Alpine from "alpinejs";

Alpine.magic("domPurify", () => async (value) => {
    const module = await import("dompurify/dist/purify.es.js");
    return module.default().sanitize(value);
});